import React from "react";
import { Box, Typography, alpha, CircularProgress } from "@mui/material";

/**
 * Barra de ações fixa no rodapé da página de cadastro.
 */
export default function ClientFormActionsBar({
  children,
  variant = "dock",
  statusText,
  hintText,
  isBusy = false,
}) {
  if (variant === "embedded") {
    return (
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, py: 2 }}>
        {children}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        py: 1.5,
        px: 0,
        mt: 1,
        borderTop: "1px solid",
        borderColor: (t) => alpha(t.palette.divider, 0.95),
      }}
    >
      <Box sx={{ minWidth: 0, flex: 1, display: { xs: "none", sm: "block" } }}>
        {statusText ? (
          <Typography variant="body2" fontWeight={600} color="text.primary" noWrap>
            {isBusy ? (
              <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={14} />
                Salvando alterações…
              </Box>
            ) : (
              statusText
            )}
          </Typography>
        ) : null}
        {hintText && !isBusy ? (
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.25 }}>
            {hintText}
          </Typography>
        ) : null}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.25, flexShrink: 0 }}>
        {children}
      </Box>
    </Box>
  );
}
